export default __webpack_public_path__ + "static/media/innovacion.9330a299.png";